class OnBoardingContentController {
    constructor(settings, analyticsService, sessionStorage) {
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.sessionStorage = sessionStorage;
    }

    $onInit() {
        if (this.sessionStorage.getJsonAndRemove('ShowRewardsOnboardingSignUp')) {
            this.titleContent = this.settings.onBoarding.titleSignUpContent;
            this.textContent = this.settings.onBoarding.textSignUpContent;
        } else {
            this.titleContent = this.settings.onBoarding.titleLoginContent;
            this.textContent = this.settings.onBoarding.textLoginContent;
        }

        this.bannerUrl = this.settings.onBoarding.bannerImageUrl;
        this.cardImage = this.settings.rewards.accountImageFloat;
        this.dialogCtrl.show();
    }
}

const onBoardingContentComponentDefinition = {
    controller: ['Settings', 'AnalyticsService', 'SessionStorageWrapper', OnBoardingContentController],
    require: { dialogCtrl: '^dialog' },
    template: require('./onboarding-dialog-content.component.html').trim(),
};

module.exports = {
    OnBoardingContentController,
    onBoardingContentComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/onboarding/onboarding-dialog-content.component.js